var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tasks" },
    [
      _c("a-table", {
        attrs: {
          dataSource: _vm.sortedTasks,
          columns: _vm.columns,
          pagination: false,
          loading: _vm.loading,
        },
        scopedSlots: _vm._u([
          {
            key: "subject",
            fn: function (text) {
              return _c("span", {}, [_vm._v(_vm._s(text))])
            },
          },
          {
            key: "owner",
            fn: function (owner) {
              return _c("span", {}, [_vm._v(_vm._s(owner.name))])
            },
          },
          {
            key: "status",
            fn: function (status) {
              return _c(
                "span",
                {},
                [
                  _c(
                    "a-tag",
                    { attrs: { color: _vm.getStatusColor(status) } },
                    [_vm._v(_vm._s(status))]
                  ),
                ],
                1
              )
            },
          },
          {
            key: "priority",
            fn: function (priority) {
              return _c(
                "span",
                {},
                [
                  _c(
                    "a-tag",
                    { attrs: { color: _vm.getPriorityColor(priority) } },
                    [_vm._v(_vm._s(priority))]
                  ),
                ],
                1
              )
            },
          },
          {
            key: "dueDate",
            fn: function (dueDate) {
              return _c("span", {}, [_vm._v(_vm._s(_vm.formatDate(dueDate)))])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }